import {IssuesCloseOutlined, WarningOutlined} from '@ant-design/icons';
import PropTypes from 'prop-types';
import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';

import DatePreview from '@/components/DatePreview';
import DatePreviewWithRange from '@/components/DatePreviewWithRange';
import {Tooltip} from '@/components/Tooltip';

const CNAProperties = ({value}) => {
  const {t} = useTranslation('configuration');
  
  return (<>
    {
      value?.commercialization &&
      <Tooltip title={t('CNAENomenclator.alerts.commercialization')} placement="left" className="truncate">
        <span className="text-primary px-2">
          <IssuesCloseOutlined/>
        </span>
      </Tooltip>
    }
    {
      value?.disabledUntilDate && <div className='px-2 flex items-center gap-1 text-warning'>
        <Tooltip
          title={<>
            {t('company:procedureDetail.tcpSuspensionOfActivities.disableUntilDate')}:
            <span className="ml-1"><DatePreview value={value?.disabledUntilDate}/></span>
          </>}
          placement="left"
          className="truncate"
        >
          <WarningOutlined/>
        </Tooltip>
        <DatePreviewWithRange value={value?.disabledUntilDate} onlyRange/>
      </div>
    }
    {
      value?.isPartiallyProhibited &&
      <Tooltip title={t('CNAENomenclator.alerts.isPartiallyProhibited')} placement="right">
        <span className="text-warning pr-2">
          <WarningOutlined/>
        </span>
      </Tooltip>
    }
  </>);
  
};

CNAProperties.propTypes = {
  value: PropTypes.any
};

export default memo(CNAProperties);
